import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum"
import customAPI from "../api/customAPI.js"
const { invoice } = stateEnum
let initialState = {
  billno: "",
  acid: "",
  detail: [],
}
export const setInvoiceDetail = createAsyncThunk(
  "invoice/fetchInvoiceDetail",
  async ({ token, comp_code, acid, billno, billtype, db_user }) => {
    
    try {
      const { data } = await customAPI.post(
        apiRoute.report.invoice.fetchInvoiceDetail,
        {
          compcode: comp_code,
          ac_id: acid,
          bill_no: billno,
          bill_type: billtype,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)



const invoiceSlice = createSlice({
  name: invoice,
  initialState,
  reducers: {

    resetReportDetail: (state, action) => {
      state.detail = []
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(setInvoiceDetail.fulfilled, (state, action) => {
        state.detail = action.payload
      })
      .addCase(setInvoiceDetail.rejected, (state, action) => {
        state.detail = []
      })
  },
})
export const { setInvoiceData ,resetReportDetail} = invoiceSlice.actions
export default invoiceSlice.reducer
